import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { IconButton, Snackbar as MuiSnackbar, SnackbarContent } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import styles from './Snackbar.module.css';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
};

const Snackbar = (props) => {
  const { action, open, message, variant, showCloseButton, onClose, className, ...other } = props;
  const Icon = variantIcon[variant];

  const renderIcon = () => {
    switch (variant) {
      case 'default':
      case 'info':
        return null;

      default:
        return (
          <Icon
            className={cn(styles.icon, {
              [styles.iconVariant]: true,
            })}
          />
        );
    }
  };

  const renderMessage = () => {
    return (
      <span id="message-id" className={styles.message}>
        {renderIcon()}
        {message}
      </span>
    );
  };

  const renderActionButtons = () => {
    const actionButtons = [
      action && action,
      showCloseButton && (
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon className={styles.icon} />
        </IconButton>
      ),
    ];

    return actionButtons;
  };

  return (
    <MuiSnackbar open={open} onClose={onClose} className={styles.root} {...other}>
      <SnackbarContent
        className={cn(
          styles.content,
          {
            [styles[variant]]: true,
          },
          className,
        )}
        aria-describedby="message-id"
        message={renderMessage()}
        action={renderActionButtons()}
      />
    </MuiSnackbar>
  );
};

Snackbar.propTypes = {
  open: Type.bool,
  anchorOrigin: Type.shape({
    horizontal: Type.oneOf(['left', 'center', 'right']).isRequired,
    vertical: Type.oneOf(['top', 'bottom']),
  }),
  message: Type.node,
  autoHideDuration: Type.number,
  className: Type.string,
  variant: Type.oneOf(['default', 'error', 'info', 'success', 'warning']),
  showCloseButton: Type.bool,
  action: Type.node,
  onClose: Type.func,
};

Snackbar.defaultProps = {
  open: false,
  message: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  className: '',
  autoHideDuration: 4000,
  showCloseButton: false,
  variant: 'default',
  action: null,
  onClose: noop,
};

export default Snackbar;
